import React from "react";
import { Link } from "react-router-dom";

const linkStyle = {
  color: "#fff",
  textDecoration: "underline",
};

const Footer = () => {
  return (
    <footer
      style={{
        width: "100%",
        padding: "20px 10px",
        backgroundColor: "#2e7d32",
        color: "#fff",
        textAlign: "center",
        fontSize: "0.9rem",
        lineHeight: "1.5",
        marginTop: "20px",
      }}
    >
      <p>© 2026 Client Exchange. All rights reserved.</p>

  <p
  style={{
    marginTop: "8px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "6px",
  }}
>
  <Link to="/support" style={linkStyle}>
    Support
  </Link>{" "}
  |{" "}
  <Link to="/contact" style={linkStyle}>
    Contact Us
  </Link>{" "}
  |{" "}
  <Link to="/why-verify" style={linkStyle}>
    Why We Verify
  </Link>{" "}
  |{" "}
  <Link to="/client-transfer-guidelines" style={linkStyle}>
    Client Transfer Guidelines
  </Link>{" "}
  |{" "}
  <Link to="/blog" style={linkStyle}>
  Blog
</Link>{" "}
  <Link to="/legal" style={linkStyle}>
    Privacy Policy
  </Link>{" "}
  |{" "}
  <Link to="/terms" style={linkStyle}>
    Terms of Use
  </Link>

|{" "}
<Link to="/cookie-policy" style={linkStyle}>
  Cookie Policy
</Link>
</p>

      <p style={{ marginTop: "8px" }}>
        Email:{" "}
        <a
          href="mailto:support@clientexchange.com.au"
          style={linkStyle}
        >
          support@clientexchange.com.au
        </a>
      </p>

      <p style={{ marginTop: "8px", fontWeight: "600", opacity: 0.95 }}>
        Australia’s Verified Marketplace for Service Businesses
      </p>
      <p style={{ marginTop: "8px", fontSize: "13px", opacity: 0.8 }}>
  Client Exchange Pty Ltd | ABN 23 692 732 157
</p>
    </footer>
  );
};

export default Footer;